import { BaseSerializer } from '../base.serializer'
import { OnlineInterviewerShedulePeriod } from 'models'
import { OnlineInterviwerScheduleShiftSerializer } from './online-interviewer-schedule-shift.serializer'

export class OnlineInterviwerSchedulePeriodSerializer extends BaseSerializer<OnlineInterviewerShedulePeriod> {
  
  static SERIALIZABLE_ATTRIBUTES = [
    "id", "name", "beginningAt", "endingAt", "size", "order", "state", "periodType", "shifts",
    "onlineInterviewerScheduleId"
  ]
  static SERIALIZERS = {
    shifts: OnlineInterviwerScheduleShiftSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    shifts: "shifts_attributes"
  }

  static DESERIALIZERS = {
    shifts: OnlineInterviwerScheduleShiftSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): OnlineInterviewerShedulePeriod {
    return new OnlineInterviewerShedulePeriod(attributes)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/online-interviewer-schedule/online-interviewer-schedule-period.serializer.ts